<template>
	<NuxtLink
		v-slot="{ href }"
		custom
		:to="
			PropertyFiltersPresenter.getPathFromFilters(
				filters,
				{},
				{ page: 'mapa-de-imoveis' }
			)
		"
	>
		<Button
			as="a"
			variant="secondary"
			size="sm"
			:href="href"
			class="absolute inset-x-5 top-1/2 h-11 w-[calc(100%-40px)] -translate-y-1/2 shadow-[0px_2px_6px_2px_rgba(0,0,0,0.15)] md:bottom-10 md:left-auto md:right-5 md:top-auto md:w-min md:translate-y-1/2"
			@click="handleClick"
		>
			<IconMaterialSymbolsLightMapOutline class="size-5 text-primary" />
			Ver imóveis no Mapa
		</Button>
	</NuxtLink>
</template>
<script setup lang="ts">
import type { PropertyFilters } from '~/core/entities/property/filters';
import { PropertyFiltersPresenter } from '~/presenters/PropertyFiltersPresenter';

defineProps<{
	filters: PropertyFilters;
}>();

const emits = defineEmits<{
	(e: 'open-map-vision'): void;
}>();

function handleClick() {
	emits('open-map-vision');
}
</script>
